"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MultiComboBoxTokenizer = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _List = require("../List/List");
var _Overlay = require("../Overlay/Overlay");
var _constants = require("../utils/constants");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _listboxUtils = require("../List/_listboxUtils");
var _MultiComboBoxToken = require("./_MultiComboBoxToken");
var _MultiComboBoxTokenizer = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MultiComboBoxTokenizer.css") : void 0);
var _excluded = ["className", "closeLabel", "disabled", "onClose", "itemKey", "itemText", "overflowTokenLabel", "onOverflowTokenClick", "overflowTokenRef", "onKeyDown", "reservedWidthForSiblings", "selectedOptions", "size", "readOnly", "removeLabel", "validationMessageState"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-multicombobox-tokenizer';
var MultiComboBoxTokenizer = exports.MultiComboBoxTokenizer = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(MultiComboBoxTokenizer, _props)) : _props;
  var className = props.className,
    closeLabel = props.closeLabel,
    disabled = props.disabled,
    onClose = props.onClose,
    _props$itemKey = props.itemKey,
    itemKey = _props$itemKey === void 0 ? 'key' : _props$itemKey,
    _props$itemText = props.itemText,
    itemText = _props$itemText === void 0 ? 'text' : _props$itemText,
    overflowTokenLabel = props.overflowTokenLabel,
    onOverflowTokenClick = props.onOverflowTokenClick,
    overflowTokenRef = props.overflowTokenRef,
    _onKeyDown = props.onKeyDown,
    _props$reservedWidthF = props.reservedWidthForSiblings,
    reservedWidthForSiblings = _props$reservedWidthF === void 0 ? 0 : _props$reservedWidthF,
    selectedOptions = props.selectedOptions,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    readOnly = props.readOnly,
    removeLabel = props.removeLabel,
    validationMessageState = props.validationMessageState,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_MultiComboBoxTokenizer.default);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    parentContainerWidth = _useState2[0],
    setParentContainerWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(new _map.default()),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    tokenWidth = _useState4[0],
    setTokenWidth = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    overflowItems = _useState6[0],
    setOverflowItems = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    readOnlyPopperOpen = _useState8[0],
    setReadOnlyPopperOpen = _useState8[1];
  var setRefs = (0, _react.useRef)(new _map.default()).current;
  var tokenizerRef = (0, _react.useRef)();
  var mergedRef = (0, _reactMergeRefs.default)([ref, tokenizerRef]);
  var getParentWidth = function getParentWidth(itemRef) {
    var _itemRef$current;
    return (itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || (_itemRef$current = _itemRef$current.parentNode) === null || _itemRef$current === void 0 ? void 0 : _itemRef$current.clientWidth) || 0;
  };
  var detectWrap = function detectWrap() {
    var wrappedItems = [];
    var totalWidthOfTokens = 0;
    var maxWidthForTokens = parseInt(parentContainerWidth - reservedWidthForSiblings, 10);
    selectedOptions.forEach(function (child) {
      if (!child) return;
      var childKey = (0, _listboxUtils.reduceOption)(child, itemKey);
      var tokenDimensions = setRefs.get(childKey) ? setRefs.get(childKey).getBoundingClientRect() : 0;
      if (tokenDimensions.width > 0) {
        setTokenWidth(tokenWidth.set(childKey, tokenDimensions.width));
      }
      if (tokenWidth.get(childKey)) {
        totalWidthOfTokens += tokenWidth.get(childKey);
      }
      if (totalWidthOfTokens > maxWidthForTokens) {
        wrappedItems.push(child);
      }
    });
    return wrappedItems;
  };
  (0, _useUniversalLayoutEffect.default)(function () {
    if (parentContainerWidth > 0) {
      setOverflowItems(detectWrap());
    }
  }, [parentContainerWidth, selectedOptions]);
  var handleResize = function handleResize() {
    setParentContainerWidth(getParentWidth(tokenizerRef));
  };
  (0, _useUniversalLayoutEffect.default)(function () {
    handleResize();
  }, []);

  // runs on every resize
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });
  var classes = classnames(CSS_BLOCK, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--disabled"), disabled), "".concat(CSS_BLOCK, "--readonly"), readOnly), (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, validationMessageState), validationMessageState), className);
  var passChildProps = function passChildProps(child, childProps) {
    if (child.displayName === 'MultiComboBoxToken') {
      var _context2;
      return {
        className: classnames("".concat(CSS_BLOCK, "__token"), (0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "__token--")).call(_context2, size), size !== 'md'), childProps.className),
        readOnly: readOnly,
        disabled: disabled,
        size: size,
        validationMessageState: validationMessageState
      };
    }
    return null;
  };
  var handleOverflowClick = function handleOverflowClick(e) {
    if (readOnly) {
      setReadOnlyPopperOpen(true);
    }
    if (!disabled) {
      onOverflowTokenClick(e);
    }
  };
  var overflowToken = /*#__PURE__*/_react.default.createElement(_MultiComboBoxToken.MultiComboBoxToken, {
    key: "token-overflow",
    "data-nui-widgets": "token-overflow",
    overflow: true,
    onClick: handleOverflowClick,
    onKeyDown: function onKeyDown(e) {
      if (!disabled) {
        _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, null);
      }
    },
    textProps: {
      ref: overflowTokenRef
    }
  }, overflowItems.length, " ", overflowTokenLabel);
  var renderTokens = function renderTokens() {
    var tokenChildren = selectedOptions ? (0, _filter.default)(selectedOptions).call(selectedOptions, function (val) {
      return overflowItems.indexOf(val) === -1;
    }) : [];
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _map2.default)(tokenChildren).call(tokenChildren, function (item) {
      if (!item) return null;
      var tokenKey = (0, _listboxUtils.reduceOption)(item, itemKey);
      return /*#__PURE__*/_react.default.createElement(_MultiComboBoxToken.MultiComboBoxToken, {
        removeLabel: removeLabel || closeLabel,
        key: "token-".concat(tokenKey),
        ref: function ref(node) {
          return !node ? setRefs.delete(tokenKey) : setRefs.set(tokenKey, node);
        },
        onClick: function onClick(e) {
          if (!disabled) {
            onClose(e, item);
          }
        },
        onKeyDown: function onKeyDown(e) {
          if (!disabled) {
            _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, item);
          }
        }
      }, (0, _listboxUtils.reduceOption)(item, itemText));
    }), !!overflowItems.length && !readOnly > 0 && overflowToken, !!overflowItems.length && readOnly > 0 && /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, {
      show: readOnlyPopperOpen,
      showArrow: true,
      targetComponent: overflowToken,
      widthSizingType: "minTarget",
      className: classnames("".concat(CSS_BLOCK, "__popper")),
      offset: 10,
      focusManagerProps: {
        nextKeyCode: _keycode.default.codes.down,
        previousKeyCode: _keycode.default.codes.up
      }
    }, /*#__PURE__*/_react.default.createElement(_List.List, {
      className: classnames("".concat(CSS_BLOCK, "__list"))
    }, (0, _map2.default)(selectedOptions).call(selectedOptions, function (item) {
      return /*#__PURE__*/_react.default.createElement(_List.List.Item, {
        key: (0, _listboxUtils.reduceOption)(item, itemKey)
      }, (0, _listboxUtils.reduceOption)(item, itemText));
    }))));
  };
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: mergedRef
  }), renderTokens()));
});
MultiComboBoxTokenizer.displayName = 'MultiComboBoxTokenizer';
MultiComboBoxTokenizer.propTypes = {
  /** Text for overflow token - usually "More" */
  overflowTokenLabel: _propTypes.default.string.isRequired,
  /** Additional class(es) added to the outermost `<div>` element. */
  className: _propTypes.default.string,
  /** @deprecated Accessibility label for the close icon in each **Token** component. */
  closeLabel: _propTypes.default.string,
  /** Set to `true` to disable the component. */
  disabled: _propTypes.default.bool,
  /** Used to identify the unique key for a list item. It identifies the field in
   * the data to use as the key value for the list item.
   */
  itemKey: _propTypes.default.string,
  /** Used to identify the text for a list item. It identifies the field
   * in the data to use as the text for the list item.
   */
  itemText: _propTypes.default.string,
  /** Set to `true` to set the component to readOnly state. */
  readOnly: _propTypes.default.bool,
  /** Accessibility label for the remove icon in each **Token** component. */
  removeLabel: _propTypes.default.string,
  /** The width (in pixels) of the parent container's width that cannot
   * be used for tokens.  If tokens extend beyond that, they will be added
   * to the overflow popover. */
  reservedWidthForSiblings: _propTypes.default.number,
  /** Array of items to render in **Token** components. */
  selectedOptions: _propTypes.default.array,
  /** The size of the **Token**s and control: 'lg' or 'md' */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** Ref for overflow **Token** */
  overflowTokenRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  /** Sets the validation state styling - 'error', 'warning'. */
  validationMessageState: _propTypes.default.oneOf(_constants.FORM_CONTROL_VALIDATION_STATES),
  /** Callback for when the **Token** is clicked */
  onClose: _propTypes.default.func,
  /** Callback for when the **Token** is clicked via keyboard. */
  onKeyDown: _propTypes.default.func,
  /** Callback for when the overflow **Token** is clicked */
  onOverflowTokenClick: _propTypes.default.func
};
var _default = exports.default = MultiComboBoxTokenizer;